import { IDeserialize } from "../abstraction/IDeserialize";
import { Version } from "./Version";

export class Changelog implements IDeserialize<Changelog> {
  description = "";
  title = "";
  versions: Version[] = [];

  deserialize(log: Changelog): Changelog {
    Object.assign(this, log);

    if (log.versions && log.versions.length) {
      this.versions = [];
      log.versions.forEach((element) => {
        const version = new Version().deserialize(element);
        this.versions.push(version);
      });
    }

    return this;
  }
}
